interface IUserMessage {
    key: string,
    messageContent: string
};

export let createMessageWithContent = (messageContent: string) => ({ key: Date.now().toString(), messageContent: messageContent });

export default IUserMessage;